import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Images } from 'lucide-react';
import SmartImage from './SmartImage';
import Lightbox from './Lightbox';
import api, { mediaUrl } from '../lib/api';

const FeaturedRecap = () => {
  const [data, setData] = useState(null);
  const [idx, setIdx] = useState(null);

  useEffect(() => {
    api.get('/programs/recap').then((r) => setData(r.data)).catch(() => setData(null));
  }, []);

  if (!data || !data.program || !(data.photos || []).length) return null;
  const { program, photos } = data;

  return (
    <section className="bg-cream py-16" data-testid="home-recap">
      <div className="max-w-[1300px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
          <div>
            <div className="eyebrow mb-2 inline-flex items-center gap-2"><Images className="w-4 h-4" /> Relive the moments</div>
            <h2 className="font-serif-display text-3xl md:text-4xl text-burgundy">{program.title}</h2>
            {program.location && <p className="text-mahogany/70 mt-1">{program.location}</p>}
          </div>
          <Link to={`/programs/${program.slug}`} data-testid="recap-view-link"
            className="pill-btn inline-flex items-center gap-2">View gallery <ArrowRight className="w-4 h-4" /></Link>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {photos.slice(0, 8).map((src, i) => (
            <button key={src + i} type="button" onClick={() => setIdx(i)} data-testid={`recap-photo-${i}`}
              className="group relative rounded-2xl overflow-hidden aspect-square focus:outline-none">
              <SmartImage src={mediaUrl(src)} alt="" className="aspect-square transition-transform duration-500 group-hover:scale-105" />
            </button>
          ))}
        </div>
      </div>
      {idx !== null && <Lightbox images={photos.map((p) => mediaUrl(p))} index={idx} onClose={() => setIdx(null)} />}
    </section>
  );
};

export default FeaturedRecap;
